import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import moment from "moment";
import { getDurationByStartEndTime } from "@saas/components/src/utils/utils";
export default {
  data: function () {
    return {
      moment,
    };
  },
  methods: {
    ...mapMutations("defaultHomework", [
      "setStartAnswer",
      "setShowAnswerReport",
      "setShowErrorAnalysis",
    ]),
    ...mapActions("defaultHomework", ["apiGetQuestionInfo"]),
    showAnalysis() {
      if (this.questionList?.length === 0) return;
      this.setShowAnswerReport(false);
      this.setStartAnswer(true);
      this.apiGetQuestionInfo({
        work_id: this.workInfo.id,
        question_ids: this.questionPids.join(","),
      });
    },
    showErrorAnalysis() {
      this.setShowErrorAnalysis(true);
      this.showAnalysis();
    },
  },
  computed: {
    ...mapGetters("defaultHomework", ["questionPids"]),
    ...mapState("defaultHomework", ["workInfo", "questionList", "isCorrected"]),
    handleAccuracy() {
      let { question_num = 0, right_num = 0 } = this.workInfo;
      let value = (right_num / question_num) * 100;
      return Number.isInteger(value) ? value : value.toFixed(1);
    },
    handleTotalDuration() {
      let { sub_time = 0, start_time = 0 } = this.workInfo;
      if (!sub_time || !start_time) {
        return {
          value: 0,
          unit: "秒",
        };
      }
      let { hours, minutes, second } = getDurationByStartEndTime(
        start_time,
        sub_time
      );
      if (hours) {
        return {
          value: `${hours}:${minutes < 10 ? "0" + minutes : minutes}`,
          unit: "时",
        };
      } else if (minutes) {
        return {
          value: `${minutes}:${second < 10 ? "0" + second : second}`,
          unit: "分",
        };
      } else {
        return {
          value: `${second}`,
          unit: "秒",
        };
      }
    },
  },
};
